module.exports = __webpack_public_path__ + "static/media/buttonsounds04.8e7e306c.wav";